import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IIncidents } from 'src/app/models/incident';

@Component({
  selector: 'app-visitor-ticket-dialog',
  templateUrl: './visitor-ticket-dialog.component.html',
  styleUrls: ['./visitor-ticket-dialog.component.scss'],
})
export class VisitorTicketDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IIncidents,
    private formbuilder: FormBuilder
  ) {}
  selectedOption: string;
  statusOptions: string[] = ['Open', 'Close', 'Verified'];
  visitorTicket = this.formbuilder.group({
    ticketSubject: ['', Validators.required],
    ticketDescription: ['', Validators.required],
  });
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
}
